var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6886 18.6688L16.3886 13.3688H15.3986L12.8586 15.9088V16.8988L18.1586 22.1988C18.5486 22.5888 19.1786 22.5888 19.5686 22.1988L21.6886 20.0788C22.0786 19.6988 22.0786 19.0588 21.6886 18.6688ZM18.8586 20.0888L14.6186 15.8488L15.3286 15.1388L19.5686 19.3788L18.8586 20.0888Z",
    fill: "#6B6E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3586 10.6888L18.7686 9.27878L20.8886 11.3988C22.0586 10.2288 22.0586 8.32878 20.8886 7.15878L17.3486 3.61878L15.9386 5.02878V2.20878L15.2386 1.49878L11.6986 5.03878L12.4086 5.74878H15.2386L13.8286 7.15878L14.8886 8.21878L11.9986 11.1088L7.86855 6.97878V5.55878L4.84855 2.53878L2.01855 5.36878L5.04855 8.39878H6.45855L10.5886 12.5288L9.73855 13.3788H7.61855L2.31855 18.6788C1.92855 19.0688 1.92855 19.6988 2.31855 20.0888L4.43855 22.2088C4.82855 22.5988 5.45855 22.5988 5.84855 22.2088L11.1486 16.9088V14.7888L16.2986 9.63878L17.3586 10.6888ZM9.37855 15.8388L5.13855 20.0788L4.42855 19.3688L8.66855 15.1288L9.37855 15.8388Z",
    fill: "#6B6E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.fef8bae7baa2c9c9d4b2fe45ee618593.svg";
export { ForwardRef as ReactComponent };